// extracted by mini-css-extract-plugin
export default {"app":"App_app__D8w49","main":"App_main__BeVuK","footer":"App_footer__07pim"};